import { createContext } from "react";
import { IRCACorporateDashboardContext } from "./RCACorporateDashboardContextInterfaces";
import {
    RCAAPComplianceByResponsibleFilterEnum,
    RCAAPComplianceRangeEnum,
} from "pages/Corporate/RCA/RCAAPCompliance/RCAAPComplianceInterfaces";
import { ComplianceTypes } from "constants/constants";

export const initialState: IRCACorporateDashboardContext = {
    filters: {
        periodOption: RCAAPComplianceRangeEnum.thirty as unknown as number,
        typeOption: RCAAPComplianceByResponsibleFilterEnum["a_to_z_asc"],
        complianceType: ComplianceTypes.NONE,
        divisionIds: [],
        totalDivisions: 0,
        regionIds: [],
        totalRegions: 0,
    },
    handleSetFilters: () => {},
    handleSetTypeFilter: () => {},
    handleSetComplianceType: () => {},
    handleSetDivisions: () => {},
    handleSetRegions: () => {},
    handleRemoveDefaultFilters: async () => {},
    handleSetFiltersDefault: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
    isFiltersDefault: false,
};

export const RCACorporateDashboardContext = createContext(initialState);
